import loginService from '../services/loginService'
import routes from 'consts/routes'

export const isWelcomeBackRoute = state =>
  /^\/welcome-back.*/.test(state.router.location.pathname)

export const isRootRoute = state =>
  state.router.location.pathname === routes.ROOT

export const getParameterFromURL = (state, parameter) => {
  const location = state.router.location
  const queryParams = new URLSearchParams(location.search)
  return queryParams.get(parameter)
}

// when there is application id and token -> request data
// when there is no application id or not token -> redirect to welcome home screen (if not already there)

export const shouldRequstData = state => {
  const applicationId = getParameterFromURL(state, 'application_id')
  const token = loginService.getToken()
  return !!applicationId && !!token
}

export const shouldRedirectToWelcomeHomeScreen = state => {
  const applicationId = getParameterFromURL(state, 'application_id')
  const token = loginService.getToken()
  return (
    (!applicationId || !token) &&
    state.app?.locationRoute?.pathname !== routes.ROOT &&
    !isWelcomeBackRoute(state)
  )
}
